import { Box } from '@mui/material';
import { styled } from '@mui/system';

const FooterNoFlex = styled(Box)({
    display: 'flex',
    gap: '70px',
    flexWrap: 'wrap',
    justifyContent: "space-between",
    background: 'linear-gradient(90deg, #89C8EE 0.2%, #A1D78C 99.79%)',
    padding: '4rem 5rem',
});

const FooterContainer = styled(Box)({
    color: '#000',
    display: 'flex',
    width: 'max-content',
    gap: '20px',
    rowGap: '60px',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
});

const Column = styled(Box)({
    minWidth: '200px',
    alignSelf: 'center',

});

const List = styled(Box)({
    listStyle: 'none',
    padding: 0,
});

const ListHeading = styled(Box)({
    color: '#000000a7',
    fontSize: '14px',
    marginBottom: '20px'
});

const ListItem = styled(Box)({
    marginBottom: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
});

export { Column, FooterContainer, FooterNoFlex, List, ListHeading, ListItem };

